const MessageConstants = {
  ERROR_LOGIN: 'Kombinasi email atau kata sandi yang kamu masukkan salah!',
  SUCCESS_REGISTER: 'Registrasi kamu berhasil! \nSilahkan cek email kamu untuk melakukan konfirmasi.',
  ERROR_COMPLETE_PROFILE: 'Terjadi kesalahan saat mencoba melengkapi profil',
  SUCCESS_VERIFIED: 'Akun kamu berhasil diverfikasi! \nSilahkan masuk.',
  EMAIL_SUCCESSFULLY_SENT: 'Alby mengirimi Anda email berisi tautan untuk mengatur ulang kata sandi'
};

export default MessageConstants;
